import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { User, Menu, Notification } from '../_shared/models';
import { MatSnackBar } from '@angular/material';
import {
  AuthenticationService,
  UserService,
  ProfilePictureService,
  NotificationService,
  MenuService,
  LoadingService
} from '../_shared/services';

import { Granule } from '../config';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: [
    './navbar.component.css',
    './navbar-eas.component.css',
    '../../assets/css/core-navbar.css'
  ]
})
export class NavbarComponent implements OnInit {
  @ViewChild('changeprofpic') changeprofpic: any;
  private pictureSubscriber: Subscription = new Subscription();
  private user: User;
  private userMenu: Menu[];
  private showNavbar: boolean;
  private toggleChild: any;
  private isNavbarToggled: boolean = false;
  private isMobileMenuToggled: boolean = false;
  private isSearchbarToggled: boolean = false;
  private searchKey: string = '';
  private role_selected: number;
  private notifErrorModal = false;
  private notifSuccessModal = false;
  private message = '';
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;
  private notifications: Notification = new Notification();

  constructor(
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private profilepictureService: ProfilePictureService,
    private authenticationService: AuthenticationService,
    private menuService: MenuService,
    private loadingService: LoadingService,
    private userService: UserService,
    private router: Router,
    private granule: Granule,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    let isFirstTime: boolean;
    this.authenticationService.isFirstTime.subscribe(value => {
      isFirstTime = value;
      // isFirstTime false = showNavbar true
      this.showNavbar = !isFirstTime;
    });

    // get user menu from route resolver
    this.userMenu = this.route.snapshot.data['menu'];

    // get notifications and selected role
    this.authenticationService.userInfo.subscribe(userInfo => {
      this.user = userInfo;
      this.role_selected = userInfo.selected_role_div;
      this.getNotification(); // atut aku darl delete2 gitu itu ku cut koq
    });
  }

  getNotification() {
    this.notificationService.getNotifications().subscribe(res => {
      this.notifications = res.data;
    });
  }

  closeChild() {
    this.toggleChild = null;
  }

  childMenuToggle(item: any) {
    // toggle state of the child (opened or closed)
    if (this.toggleChild === item) this.toggleChild = null;
    else this.toggleChild = item;
  }

  isActive(item: any) {
    return this.toggleChild === item;
  }

  closeNotifModal() {
    this.notifErrorModal = false;
    this.notifSuccessModal = false;
    this.message = '';
  }

  dataHasErrors(message: string) {
    this.message = message;
    this.notifErrorModal = true;
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  searchToggle($event: any) {
    this.isSearchbarToggled = !this.isSearchbarToggled;
  }

  switchRole(i: number) {
    this.load(true);
    this.authenticationService.switchRole(i).then(res => {
      let userInfo = this.authenticationService.getUserInfo();
      let data = {
        type: 'user',
        role_id: userInfo.current_role.role_id
      };
      this.menuService.getMenu(data).then(res => {
        this.userMenu = res.data;
        this.load(false);
      });
    });
  }

  search() {
    // if the form is pristine or doesn't have any key, closes the search bar
    if (this.searchKey === '') {
      this.isSearchbarToggled = false;
    } else {
      // submit search key
      console.log(this.searchKey);
      this.router.navigate(['searchresult/' + this.searchKey]);
    }
  }

  toggleSidebar($event: any) {
    if (
      $event.target.className.includes('ti-menu') &&
      this.isMobileMenuToggled
    ) {
      // close mobile menu and search bar when user click this
      this.isMobileMenuToggled = false;
      this.isSearchbarToggled = false;
    }
    this.isNavbarToggled = !this.isNavbarToggled;
  }

  toggleMobileMenu($event: any) {
    if (
      $event.target.className.includes('ti-view-grid') &&
      this.isNavbarToggled
    ) {
      // close sidebar when user click this
      this.isNavbarToggled = false;
    }
    this.isMobileMenuToggled = !this.isMobileMenuToggled;
  }

  uploadPicture(event: any, input: any) {
    const file: FileList = event.target.files; // get files from change event in browse button
    this.profilepictureService.pictureValidation(file, this.user._id);
    this.changeprofpic.nativeElement.value = '';
  }

  logout() {
    this.showNavbar = false;
    this.authenticationService.setIsFirstTime(true);
    this.authenticationService.logout();
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/navbar/navbar.component.ts